import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Foundationcss.css'
import foundationlogo from '../Assets/Images/found.jpg'

function Foundationnavbar({openSidebar}) {

    useEffect(() => {
         document.getElementById("user").innerHTML = localStorage.getItem("username");
         document.getElementById("role").innerHTML = localStorage.getItem("RoleName");
      });

    return (
        
        <div className="kdpfound-navbar">
        <div className="kdpfound-nav-icon" >
        <i className='fas fa-stream fa-beat' onClick={openSidebar}></i>
        <i class="fa-solid fa-xmark" style={{display:"none"}}></i>
        </div>

        <div className='kdpfound-navbar-left'>
        <div className='kdpfound-sidebar-img'>
        {/* <img src={foundationlogo} alt="logo"/>&nbsp; &nbsp; */}
       </div>
         {/* <a href='#'>Subscribers</a>
         <a href='#'>Video Management</a>
         <a  className='active-link' href='#'>Admin</a> */}
     </div>


     <div className='kdpfound-navbar-right'>
         {/* <a href='#'>
             <i className='fa fa-search'></i>
         </a>
         <a href='#'>
             <i className='fa fa-clock-o'></i>
         </a> */}
      
         <i class="fa fa-user-circle" aria-hidden="true"></i>
   
         <div className='kdpfound-right-navbar'>
         <span id="user"></span>&nbsp;
         (<span id="role"></span>)
         </div>
          
     </div>


     </div>
    );
}

export default Foundationnavbar;